module.exports = __webpack_public_path__ + "static/media/confetti.1b02ef28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Ranking/confetti.svg
// module id = 1431
// module chunks = 1